import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { InfoItemDd, InfoItemDt, InfoItemList, SectionHeader } from '../../../common';
import { CustomerCompany } from '../types';
import { State } from '../reducer';
import EditCompanyModal from './EditCompanyModal';
import { Button } from '../../../../components/Buttons';
import styled from 'styled-components/macro';

interface Props extends WithTranslation {
    company: CustomerCompany | undefined;
    accountId: string;
    customerId: string;
    companyState: State;
    openEditModal: () => void;
    closeEditModal: () => void;
    editCustomerCompany: (accountId: string, id: string, values: CustomerCompany) => void;
}

const Company = (
    {
        company,
        accountId,
        customerId,
        companyState,
        closeEditModal,
        openEditModal,
        editCustomerCompany,
        t,
    }: Props
) => {
    const { modalOpen } = companyState;

    const saveEditedCompany = (values: CustomerCompany) => {
        editCustomerCompany(accountId, customerId, values);
    };

    return (
        <Container>
            <SectionHeader>{t('customers.customer.company.title')}</SectionHeader>
            <InfoItemList>
                <InfoItemDt>{t('customers.customer.company.business_name')}</InfoItemDt>
                <InfoItemDd>
                    {company?.bussiness_name || 'N/A'}
                </InfoItemDd>
            </InfoItemList>

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.company.organization_number')}</InfoItemDt>
                <InfoItemDd>
                    {company?.organization_number || 'N/A'}
                </InfoItemDd>
            </InfoItemList>

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.company.industry')}</InfoItemDt>
                <InfoItemDd>
                    {company?.industry || 'N/A'}
                </InfoItemDd>
            </InfoItemList>

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.company.website')}</InfoItemDt>
                <InfoItemDd>
                    {company?.website || 'N/A'}
                </InfoItemDd>
            </InfoItemList>

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.company.number_of_employees')}</InfoItemDt>
                <InfoItemDd>
                    {company?.number_of_employees || 'N/A'}
                </InfoItemDd>
            </InfoItemList>

            <InfoItemList>
                <InfoItemDt>{t('customers.customer.company.department')}</InfoItemDt>
                <InfoItemDd>
                    {company?.department || 'N/A'}
                </InfoItemDd>
            </InfoItemList>

            <ButtonContainer>
                <Button onClick={openEditModal}>{t('customers.customer.company.form.edit')}</Button>
            </ButtonContainer>

            {modalOpen && (
                <EditCompanyModal saveCompany={saveEditedCompany} accountId={accountId} customerId={customerId} company={company} closeModal={closeEditModal}/>
            )}

        </Container>
    );
};

export default withTranslation()(Company);

const Container = styled.div`
    flex: 0 0 50%;
    position: relative;
    @media (max-width: 1024px) {
        flex: 1 0 100%;
    }
`;


const ButtonContainer = styled.div`
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.5);
    ${Container}:hover & {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
